import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionSujetoExcluidoProducto} from '../../../../actions/action-creators'
import {sujetoExcluidoArrayProductoSelectOne, sujetoExcluidoModalsOpenEliminar, sujetoExcluidoOpenModalEditar, } from '../../../../actions/sujeto-excluido/sujetoExcluidoProductos.actions'
import TablaFacturacionSE from './TablaFacturacionSE'

const SETable1 = () => {
  const arrayProductos = useSelector((state: State) => state.sujetoExcluido.arrayProductos)
  const calculos = useSelector((state: State) => state.sujetoExcluido.calculosArrayProductos)
  const checkReteRenta = useSelector((state: State) => state.sujetoExcluido.formCliente.checkReteRenta)
  const datosEmisor = useSelector((state: State) => state.catalogos.datosEmisor)
  const idDoc = useSelector((state: State) => state.documentos.activeDoc?.idDoc)
  const dispatch = useDispatch()
  const {sujetoExcluidoCalculoTotalArrayProducto} = bindActionCreators(actionSujetoExcluidoProducto, dispatch)

  useEffect(() => {
    sujetoExcluidoCalculoTotalArrayProducto()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrayProductos, datosEmisor, idDoc, checkReteRenta])

  const openModalEliminar = (i: number) => {
    dispatch(sujetoExcluidoArrayProductoSelectOne(i))
    dispatch(sujetoExcluidoModalsOpenEliminar())
  }

  const openModalEditar = (i: number, producto: any) => dispatch(sujetoExcluidoOpenModalEditar(i, producto))

  return (
    <>
      <h3 className='card-title l'>Detalle de Productos ó Servicios</h3>
      <div className='form-separator'></div>
      <TablaFacturacionSE datos={calculos} arrayProductos={arrayProductos} rows={arrayProductos} openModalEliminar={openModalEliminar} openModalEditar={openModalEditar} idDoc={idDoc} sinAcciones={false}  />
    </>
  )
}


export default SETable1
